import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Like = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.72577 4.64213C3.92605 2.44658 7.53307 2.46007 9.81982 4.63793L9.82126 4.6393L11.975 6.70689L14.1251 4.64277C16.3253 2.44658 19.9329 2.45986 22.2198 4.63793L22.2287 4.64634C24.4239 6.8416 24.4238 10.3583 22.2286 12.5536L22.2231 12.559L11.975 22.4965L1.73017 12.5621C1.72963 12.5616 1.72909 12.561 1.72855 12.5605C-0.575255 10.3648 -0.576182 6.83896 1.72577 4.64213ZM9.12949 5.36142C7.21771 3.54136 4.22846 3.55365 2.42855 5.35355L2.41993 5.36218C0.526827 7.16513 0.526724 10.035 2.41983 11.8379L2.42309 11.841L11.975 21.1035L21.5241 11.8438C23.3248 10.0404 23.3253 7.162 21.5258 5.35786C19.6138 3.54137 16.6273 3.55483 14.8285 5.35355L14.8213 5.36077L11.975 8.09311L9.12949 5.36142C9.12926 5.36121 9.12971 5.36164 9.12949 5.36142Z"
  />,
  'Like'
)

export default Like
